import axios_nomura from './axios-nomura.services';
import axios_mock from './axios-mock.services';

// Fetch Buy, Sell, Switch Fund Information
export const fetchSearchBuyableFunds = async (payload) => {
  return await axios_nomura.get(`/api/v1/search/buyable_funds`, { params: payload });
};

export const fetchBuyFundInfo = async (data) => {
  return await axios_nomura.post(`/api/v1/orders/buy_information`, data);
};

export const fetchBuyableFund = async (data) => {
  return await axios_nomura.post(`/api/v1/orders/buy/check`, data);
};

export const fetchSellableFund = async (data) => {
  return await axios_nomura.post(`/api/v1/orders/sell/check`, data);
};

export const fetchSwitchableOutFunds = async (data) => {
  return await axios_nomura.get(`/api/v1/search/switchable_funds`, { params: data});
};

export const fetchSwitchableFunds = async (data) => {
  return await axios_nomura.get(`/api/v1/orders/${data.accountNumber}/switchable_funds`, {
    params: {
      fundCode: data.fundCode,
      fundId: data.fundId,
      accountType: data.accountType,
      isDCA: data.isDCA
    }
  });
};

export const fetchCheckedSwitchableFund = async (data) => {
  return await axios_nomura.post(`/api/v1/orders/switch/check`, data);
};

export const fetchSellFundInfo = async (data) => {
  return await axios_nomura.post(`/api/v1/orders/sell_information`, data);
};

export const fetchSwitchFundInfo = async (data) => {
  return await axios_nomura.post(`/api/v1/orders/switch_information`, data);
};

export const fetchChannelByAccount = async (data) => {
  return await axios_nomura.get(`/api/v1/orders/payments/channels`, { params: data });
};

export const fetchSendQuestionBackToConfirm = async (data) => {
  return await axios_nomura.post(`/api/v1/orders/buy`, data);
};

export const fetchConfirmSellFund = async (data) => {
  return await axios_nomura.post(`/api/v1/orders/sell`, data);
};

export const fetchConfirmSwitchFund = async (data) => {
  return await axios_nomura.post(`/api/v1/orders/switch`, data);
};

export const fetchGetReceivingDate = async (data) => {
  return await axios_nomura.get(`/api/v1/orders/sell/receiving_date`, { params: data });
};
